module.exports = function slugify(string) {
  return string
    .split(" ")
    .join("-")
    .toLowerCase();
};
